const en = {
  loadingTypes: {
    notSpecified: 'not specified',
  },
};

export { en };
